<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useTenant, hasActiveSubscription } from '@/composables/useTenant';
import { Building2, ArrowRight, ShieldCheck, UserPlus, CreditCard } from 'lucide-vue-next';
import { NButton } from 'naive-ui';

const { t } = useI18n();
const router = useRouter();
const { activeTenant } = useTenant();

const goToDashboard = () => {
  if (!hasActiveSubscription.value) {
    router.push('/dashboard/billing');
  } else {
    router.push('/dashboard');
  }
};

const goToRegister = () => {
  router.push('/register-tenant');
};
</script>

<template>
  <div class="space-y-6">
    <div class="text-center">
      <h2 class="text-xl font-bold text-slate-100">{{ t('onboarding.joinedOrgTitle') }}</h2>
      <p class="text-xs text-slate-400 mt-1">
        {{ t('onboarding.joinedOrgSubtitle') }}
      </p>
    </div>

    <!-- Joined Tenant Card -->
    <div class="p-5 rounded-2xl bg-slate-950 border border-sky-500/40 flex items-center justify-between shadow-xl">
      <div class="flex items-center gap-3.5">
        <div class="w-12 h-12 rounded-xl bg-sky-500/20 border border-sky-500/30 flex items-center justify-center font-extrabold text-sm text-sky-400">
          <Building2 class="w-6 h-6" />
        </div>
        <div>
          <div class="flex items-center gap-1.5">
            <h3 class="font-extrabold text-base text-slate-100">{{ activeTenant.name }}</h3>
            <ShieldCheck class="w-4 h-4 text-emerald-400 shrink-0" />
          </div>
          <div class="flex items-center gap-2 mt-0.5">
            <span class="text-[10px] text-sky-400 font-bold uppercase tracking-wider">{{ t('onboarding.orgType', { type: activeTenant.type || 'COLLEGIATE' }) }}</span>
            <span class="text-[10px] font-mono text-slate-400">&bull; ID: {{ activeTenant.id }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="space-y-3 pt-2">
      <NButton
        type="primary"
        block
        size="large"
        @click="goToDashboard"
        class="font-bold text-xs shadow-lg shadow-sky-500/20"
      >
        <span>{{ t('onboarding.enterWorkspace') }}</span>
        <template #icon><ArrowRight class="w-4 h-4" /></template>
      </NButton>

      <button
        type="button"
        @click="goToRegister"
        class="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-xl border border-dashed border-slate-700 text-xs font-semibold text-slate-400 hover:text-slate-200 hover:border-slate-600 transition"
      >
        <UserPlus class="w-4 h-4" />
        <span>{{ t('onboarding.registerNewOrg') }}</span>
      </button>
    </div>
  </div>
</template>
